import type { FaireProductEntity } from "../../entity_types/product";

export const p_bbab4hn8aq: FaireProductEntity = {
  token: "p_bbab4hn8aq",
  type: "product",
  name: "JADEY - Slouchy Pant Boot, Button Snap Details",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/00a726207d48d9d722816310dcff95fad64c9e80ce30f5b40fa65d379299fb9c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c8d0f9dabf0f55fbf6cf301bed0d6f0b711e9b8794daa8c957b0dd2e16d199ba.jpeg",
    "https://cdn.faire.com/fastly/60857a08f47ea718227e544e6fc137a4d6caf9efd0ad4971b36839e6a6977514.jpeg",
  ],
  priceDollars: 22.75,
  description:
    "Effortlessly cool with a relaxed silhouette, these slouchy knee-high boots are designed to make everyday styling feel elevated. Crafted with a soft leather-look upper, subtle snap detailing, and a low stacked heel, they strike the perfect balance between laid-back and polished. The naturally draped shaft adds texture and movement, making them an easy staple for fall and winter wardrobes.\nOOTD\nPair them with skinny jeans and an oversized knit for an effortless everyday look, or style them with a flowy mini dress and a long trench for an elevated boho vibe. They also look chic with leggings, an oversized blazer, and a structured tote for a cozy, off-duty outfit.",
  tags: [],
  msrpDollars: 45.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:49:20.165Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
